import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', 'client');

        return response;
    } catch (e) { }
}

export async function getClient(id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiGet('core', `client/${id}`);

        return response.content;
    } catch (e) {
        return {};
    }
}

export async function add(newDetails: any) {
    try {
        const response = await apiPost('core', 'client', newDetails);

        return response;
    } catch (e) { }
}

export async function updateClient(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `client/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removeClient(id: any) {
    try {
        return await await apiDelete('core', `client/${id}`);
    } catch (e) { }
}

export async function LogsLookup(id: string): Promise<any> {
    try {
        const response = await apiGet('core', `logsLookup/${id}`);
        console.log(response);
        return (response as any).content;
    } catch (e) {
        console.log('POST call failed: ', e);
    }
}